import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk } from '../store';
import { firestore, firestoreLiveQuery } from '../firebase';
import { ChatData, MessageData } from '../types';
import { createCrudActions } from '../utils/redux';

let cancelLiveChats: any;
let cancelLiveMessages: any;

interface UserChatsState {
  chats: ChatData[];
  messages: MessageData[];
  chatsLoading: boolean;
  messagesLoading: boolean;
}

const initialState: UserChatsState = {
  chats: [],
  messages: [],
  chatsLoading: false,
  messagesLoading: false,
}


const chatActions = createCrudActions<ChatData, UserChatsState>({
  idKey: 'id',
  itemsKey: 'chats',
  sort: {
    field: 'updateTime',
    order: 'desc',
  }
});

const messageActions = createCrudActions<MessageData, UserChatsState>({
  idKey: 'id',
  itemsKey: 'messages',
  sort: {
    field: 'updateTime',
    order: 'desc',
  }
});


const service = createSlice({
  name: 'userChats',
  initialState,
  reducers: {
    setChatsLoading(state, action: PayloadAction<boolean>): UserChatsState {
      return { ...state, chatsLoading: action.payload, }
    },
    setMessagesLoading(state, action: PayloadAction<boolean>): UserChatsState {
      return { ...state, messagesLoading: action.payload, }
    },
    resetChats(state): UserChatsState {
      return { ...state, chats: [], chatsLoading: false, }
    },
    resetMessages(state): UserChatsState {
      return { ...state, messages: [], messagesLoading: false, }
    },

    onChatAdd: chatActions.onAdd,
    onChatAddMany: chatActions.onAddMany,
    onChatUpdate: chatActions.onUpdate,
    onChatDelete: chatActions.onDelete,

    onMessageAdd: messageActions.onAdd,
    onMessageAddMany: messageActions.onAddMany,
    onMessageUpdate: messageActions.onUpdate,
    onMessageDelete: messageActions.onDelete,
  }
});


const resetChats = (): AppThunk => async (dispatch, getState) => {
  console.log('reset chats...');
  cancelLiveChats && cancelLiveChats();
  dispatch(service.actions.resetChats());
}

const resetMessages = (): AppThunk => async (dispatch, getState) => {
  console.log('reset messages...');
  cancelLiveMessages && cancelLiveMessages();
  dispatch(service.actions.resetMessages());
}

const loadChats = (userId: string): AppThunk => async (dispatch, getState) => {
  console.log('load chats...');
  resetChats();
  dispatch(service.actions.setChatsLoading(true));

  

  cancelLiveChats = firestoreLiveQuery<ChatData>({
    query: firestore.collection('chats').where('users', 'array-contains', userId),
    onAdd: (item) => {
      console.log("onChat add...");
      dispatch(service.actions.onChatAdd(item));
    },
    onUpdate: (item) => {
      dispatch(service.actions.onChatUpdate(item));
    },
    onDelete: (item) => {
      dispatch(service.actions.onChatDelete(item));
    },
    onInitial: (items) => {
      dispatch(service.actions.onChatAddMany(items));
      dispatch(service.actions.setChatsLoading(false));
    },
    skipInitialOnAdd: true,
  })
}

const loadMessages = (chatId: string): AppThunk => async (dispatch, getState) => {
  dispatch(service.actions.setMessagesLoading(true));

  cancelLiveMessages = firestoreLiveQuery<MessageData>({
    query: firestore.collection('chats').doc(chatId).collection('chat_messages'),
    onAdd: (item) => {
      dispatch(service.actions.onMessageAdd(item));
    },
    onUpdate: (item) => {
      dispatch(service.actions.onMessageUpdate(item));
    },
    onDelete: (item) => {
      dispatch(service.actions.onMessageDelete(item));
    },
    onInitial: (items) => {
      dispatch(service.actions.onMessageAddMany(items));
      dispatch(service.actions.setMessagesLoading(false));
    },
    skipInitialOnAdd: true,
  })
}



export const actions = {
  resetChats,
  resetMessages,
  loadChats,
  loadMessages,
}

export default service.reducer;